import * as React from 'react'
const LMDurationDay = () => (
  <svg
    width={30}
    height={34}
    viewBox="0 0 9.2466021 9.2127733"
    fill="currentColor"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs id="defs1" />
    <g id="layer1" transform="translate(-70.132753,-145.38389)">
      <rect
        style={{
          display: "none",
          fill: "#280b0b",
          stroke: "#ffffff",
          strokeWidth: 0.529167,
          strokeLinejoin: "round",
        }}
        id="rect9"
        width={209.38908}
        height={297.40347}
        x={-0.35489929}
        y={-12.06649}
      />
      <g
        id="g127"
        transform="matrix(0.79486103,0,0,0.79486103,14.386961,31.097095)"
      >
        <path
          id="rect5"
          style={{
            fill: "var(--accent)",
            fillOpacity: 1,
            stroke: "var(--primary)",
            strokeWidth: 0.306453,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
          }}
          d="m 70.286002,146.0623 c -2.3e-5,-0.95 0.103903,-1.27462 1.257196,-1.25719 h 7.917648 c 1.257219,9.3e-4 1.257219,0.31528 1.257195,1.25719 v 1.28746 H 70.286002 Z"
        />
        <path
          id="path7"
          style={{
            fill: "#f9f9f9",
            stroke: "var(--primary)",
            strokeWidth: 0.306453,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
          }}
          d="m 70.285979,147.34976 v 6.66032 c 2.3e-5,1.40827 0.213854,1.76907 1.257093,1.75152 h 7.917483 c 0.764881,0.0116 1.375479,-0.24252 1.257507,-1.75152 v -6.66032 z"
        />
        <path
          style={{
            fill: "var(--primary)",
            fillOpacity: 0.986842,
            stroke: "var(--primary)",
            strokeWidth: 0.13857,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
          d="m 71.578258,148.34151 a 0.08639058,0.11751826 0 0 0 -0.08657,0.11776 v 1.08239 a 0.08639058,0.11751826 0 0 0 0.08657,0.11776 h 1.24327 a 0.08639058,0.11751826 0 0 0 0.08626,-0.11776 v -1.08239 a 0.08639058,0.11751826 0 0 0 -0.08626,-0.11776 z"
          id="rect7"
        />
        <path
          id="path5"
          style={{
            fill: "none",
            stroke: "var(--primary)",
            strokeWidth: 0.306453,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
          }}
          d="m 70.293323,152.39242 v 1.16093 c 2.3e-5,1.33108 0.213855,1.67213 1.257094,1.65553 h 6.86103 l 2.281759,-2.36103 0.0322,-0.45543"
        />
        <path
          style={{
            fill: "var(--primary)",
            fillOpacity: 0.986842,
            stroke: "var(--primary)",
            strokeWidth: 0.13857,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
          d="m 73.753422,148.34151 a 0.08639058,0.11751826 0 0 0 -0.08656,0.11776 v 1.08239 a 0.08639058,0.11751826 0 0 0 0.08656,0.11776 h 1.243271 a 0.08639058,0.11751826 0 0 0 0.08626,-0.11776 v -1.08239 a 0.08639058,0.11751826 0 0 0 -0.08626,-0.11776 z"
          id="path44"
        />
        <path
          style={{
            fill: "var(--primary)",
            fillOpacity: 0.986842,
            stroke: "var(--primary)",
            strokeWidth: 0.13857,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
          d="m 75.928587,148.34151 a 0.08639058,0.11751826 0 0 0 -0.08656,0.11776 v 1.08239 a 0.08639058,0.11751826 0 0 0 0.08656,0.11776 h 1.243273 a 0.08639058,0.11751826 0 0 0 0.08626,-0.11776 v -1.08239 a 0.08639058,0.11751826 0 0 0 -0.08626,-0.11776 z"
          id="path45"
        />
        <path
          style={{
            fill: "var(--primary)",
            fillOpacity: 0.989474,
            stroke: "var(--primary)",
            strokeWidth: 0.13857,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
          d="m 78.103753,148.34151 a 0.08639058,0.11751826 0 0 0 -0.08657,0.11776 v 1.08239 a 0.08639058,0.11751826 0 0 0 0.08657,0.11776 h 1.243273 a 0.08639058,0.11751826 0 0 0 0.08626,-0.11776 v -1.08239 a 0.08639058,0.11751826 0 0 0 -0.08626,-0.11776 z"
          id="path46"
        />
        <path
          style={{
            fill: "var(--primary)",
            fillOpacity: 0.989474,
            stroke: "var(--primary)",
            strokeWidth: 0.13857,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
          d="m 71.578258,150.64091 a 0.08639058,0.11751826 0 0 0 -0.08657,0.11776 v 1.08239 a 0.08639058,0.11751826 0 0 0 0.08657,0.11775 h 1.24327 a 0.08639058,0.11751826 0 0 0 0.08626,-0.11775 v -1.08239 a 0.08639058,0.11751826 0 0 0 -0.08626,-0.11776 z"
          id="path50"
        />
        <path
          style={{
            fill: "var(--primary)",
            fillOpacity: 1,
            stroke: "var(--primary)",
            strokeWidth: 0.13857,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
          d="m 73.753422,150.64091 a 0.08639058,0.11751826 0 0 0 -0.08656,0.11776 v 1.08239 a 0.08639058,0.11751826 0 0 0 0.08656,0.11775 h 1.243271 a 0.08639058,0.11751826 0 0 0 0.08626,-0.11775 v -1.08239 a 0.08639058,0.11751826 0 0 0 -0.08626,-0.11776 z"
          id="path51"
        />
        <path
          style={{
            fill: "var(--primary)",
            fillOpacity: 0.997368,
            stroke: "var(--primary)",
            strokeWidth: 0.13857,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
          d="m 75.928587,150.64091 a 0.08639058,0.11751826 0 0 0 -0.08656,0.11776 v 1.08239 a 0.08639058,0.11751826 0 0 0 0.08656,0.11775 h 1.243273 a 0.08639058,0.11751826 0 0 0 0.08626,-0.11775 v -1.08239 a 0.08639058,0.11751826 0 0 0 -0.08626,-0.11776 z"
          id="path52"
        />
        <path
          style={{
            fill: "var(--primary)",
            fillOpacity: 0.992105,
            stroke: "var(--primary)",
            strokeWidth: 0.13857,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
          d="m 78.103753,150.64091 a 0.08639058,0.11751826 0 0 0 -0.08657,0.11776 v 1.08239 a 0.08639058,0.11751826 0 0 0 0.08657,0.11775 h 1.243273 a 0.08639058,0.11751826 0 0 0 0.08626,-0.11775 v -1.08239 a 0.08639058,0.11751826 0 0 0 -0.08626,-0.11776 z"
          id="path53"
        />
        <path
          style={{
            fill: "var(--primary)",
            fillOpacity: 0.997368,
            stroke: "var(--primary)",
            strokeWidth: 0.13857,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
          d="m 71.578258,152.91713 a 0.08639058,0.11751826 0 0 0 -0.08657,0.11777 v 1.08239 a 0.08639058,0.11751826 0 0 0 0.08657,0.11775 h 1.24327 a 0.08639058,0.11751826 0 0 0 0.08626,-0.11775 v -1.08239 a 0.08639058,0.11751826 0 0 0 -0.08626,-0.11777 z"
          id="path54"
        />
        <path
          style={{
            fill: "var(--primary)",
            fillOpacity: 0.997368,
            stroke: "var(--primary)",
            strokeWidth: 0.13857,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
          d="m 73.753422,152.91713 a 0.08639058,0.11751826 0 0 0 -0.08656,0.11777 v 1.08239 a 0.08639058,0.11751826 0 0 0 0.08656,0.11775 h 1.243271 a 0.08639058,0.11751826 0 0 0 0.08626,-0.11775 v -1.08239 a 0.08639058,0.11751826 0 0 0 -0.08626,-0.11777 z"
          id="path55"
        />
        <path
          style={{
            fill: "var(--primary)",
            fillOpacity: 0.997368,
            stroke: "var(--primary)",
            strokeWidth: 0.13857,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
          d="m 75.928587,152.91713 a 0.08639058,0.11751826 0 0 0 -0.08656,0.11777 v 1.08239 a 0.08639058,0.11751826 0 0 0 0.08656,0.11775 h 1.243273 a 0.08639058,0.11751826 0 0 0 0.08626,-0.11775 v -1.08239 a 0.08639058,0.11751826 0 0 0 -0.08626,-0.11777 z"
          id="path56"
        />
        <path
          style={{
            fill: "none",
            fillOpacity: 0.997368,
            stroke: "var(--primary)",
            strokeWidth: 0.306453,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
          }}
          d="m 72.95077,144.68782 c 0,0 0.009,-0.2377 0,-0.53742 -0.009,-0.29971 -0.810642,-0.27345 -0.835976,0 -0.02534,0.27346 0,1.34082 0,1.34082 0.119817,0.20416 0.271182,0.33471 0.477703,0.33656"
          id="path58"
        />
        <path
          style={{
            fill: "none",
            fillOpacity: 0.997368,
            stroke: "var(--primary)",
            strokeWidth: 0.306453,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
          }}
          d="m 78.792423,144.68782 c 0,0 0.009,-0.2377 0,-0.53742 -0.009,-0.29971 -0.810642,-0.27345 -0.835977,0 -0.02535,0.27346 0,1.34082 0,1.34082 0.119818,0.20416 0.271184,0.33471 0.477703,0.33656"
          id="path59"
        />
        <path
          style={{
            fill: "none",
            fillOpacity: 0.997368,
            stroke: "var(--primary)",
            strokeWidth: 0.306453,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
          }}
          d="m 75.767281,144.68782 c 0,0 0.009,-0.2377 0,-0.53742 -0.009,-0.29971 -0.810642,-0.27345 -0.835975,0 -0.02534,0.27346 0,1.34082 0,1.34082 0.119818,0.20416 0.271181,0.33471 0.477702,0.33656"
          id="path60"
        />
        <path
          style={{
            fill: "none",
            fillOpacity: 1,
            stroke: "var(--primary)",
            strokeWidth: 0.306453,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
          }}
          d="m 78.41145,155.20888 -0.0033,-1.55846 c 0,0 -0.01958,-0.30584 0.233183,-0.53974 0.25277,-0.2339 0.459695,-0.26283 0.459695,-0.26283 h 1.592162"
          id="path61"
        />
      </g>
    </g>
  </svg>
)

export default LMDurationDay
